import { CheckCircleIcon, XCircleIcon } from '@langchain/untitled-ui-icons';
import {
  Button,
  FormLabel,
  Input,
  Modal,
  ModalClose,
  ModalDialog,
} from '@mui/joy';

import { useCallback, useState } from 'react';

import { useIFrameTraceRendering } from '@/hooks/useIFrameTraceRendering';

export const IFrameTraceRenderingModal = ({
  datasetId,
  sessionId,
  open,
  onClose,
}: {
  datasetId?: string;
  sessionId?: string;
  open: boolean;
  onClose: () => void;
}) => {
  const { upsertIFrameConfig, currIFrameConfig } = useIFrameTraceRendering(
    datasetId,
    sessionId
  );
  const [iframeUrl, setIFrameUrl] = useState(currIFrameConfig?.url ?? '');
  const onSubmit = useCallback(() => {
    upsertIFrameConfig({
      datasetId,
      sessionId,
      enabled: true,
      url: iframeUrl,
    });
    onClose();
  }, [datasetId, iframeUrl, onClose, sessionId, upsertIFrameConfig]);
  const onDisable = useCallback(() => {
    if (currIFrameConfig) {
      upsertIFrameConfig({
        ...currIFrameConfig,
        enabled: false,
      });
    }
    onClose();
  }, [currIFrameConfig, onClose, upsertIFrameConfig]);
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <div className="flex min-w-[400px] flex-col gap-4">
          <div className="flex flex-col gap-1">
            <div className="text-lg">Enable iframe trace rendering</div>
            <div className="max-w-[400px] flex-wrap text-sm text-tertiary">
              The output/reference output payload will be sent to the iframe on
              load via the postMessage API.
            </div>
            {/* TODO: Add an example schema */}
          </div>
          <div className="flex flex-col gap-2">
            <FormLabel>URL</FormLabel>
            <Input
              value={iframeUrl}
              onChange={(e) => setIFrameUrl(e.target.value)}
            />
            {currIFrameConfig &&
              (currIFrameConfig.enabled ? (
                <div className="flex items-center gap-2">
                  <CheckCircleIcon className="h-3 w-3 text-ls-green-600" />
                  <div className="text-sm text-tertiary">Currently enabled</div>
                </div>
              ) : (
                <div className="flex items-center gap-2">
                  <XCircleIcon className="h-3 w-3 text-error" />
                  <div className="text-sm text-tertiary">
                    Currently disabled
                  </div>
                </div>
              ))}
          </div>

          <div className="flex gap-2">
            <Button
              variant="solid"
              disabled={!iframeUrl}
              color="primary"
              onClick={onSubmit}
            >
              Enable
            </Button>
            {currIFrameConfig?.enabled && (
              <Button variant="solid" color="danger" onClick={onDisable}>
                Disable
              </Button>
            )}
          </div>
        </div>
      </ModalDialog>
    </Modal>
  );
};
